export const Quorum_SEG = 'Quorum Federal Credit Union Partner Companies';

export const KRAFT = 'The Kraft Heinz Company and its subsidiaries';
export const MASTERCARD = 'Mastercard®';
export const MONDELEZ_INTERATIONAL = 'Mondelēz International';
export const THE_OGILVY_GROUP = 'The Ogilvy Group, Inc.';
export const HITACHI_METALS = 'Hitachi Metals America, Ltd.';
export const AVON_PRODUCTS = 'Avon Products; New York and Newark, DE';
export const THIRD_ANGLE_TECHNOLOGIES = '3rd Angle Technologies';
export const ADVENTURE = 'Adventure Medical Kits';
export const ALLIED_BARTON = 'AlliedBarton Security Services';
export const ALTRIA_GROUP = 'Altria Group, Inc. and its subsidiaries';
export const Ampacet = 'Ampacet Corporation';
export const BASF = 'BASF Corporation';
export const BAY_PERSONNEL = 'Bay Personnel';
export const BISTRO = 'Bistro Foods, Inc. (Le Petit Bistro)';
export const BRESNAN = 'Bresnan Communications';
export const CARL_ZEISS = 'Carl Zeiss, Inc.';
export const CHARLES_IFERGAN = 'Charles Ifergan Coiffures';
export const COMPASS = 'Compass Group; Port Chester, NY';
export const COUNCIL_ON_INTERNATIONAL_EDUCATIONAL_EXCHANGE =
  'Council on International Educational Exchange';
export const DATA_KEY_CONSULTING = 'DataKey Consulting, LLC';
export const DIAGEO_NORTH_AMERICA = 'Diageo North America, Inc.';
export const DIAMOND_RESORTS_INTERNATIONAL = 'Diamond Resorts International';
export const DURA_SUPREME = 'Dura Supreme, Inc.';
export const FILA = 'Fila U.S.A., Inc.';
export const GAME_SPORTSWEAR = 'GAME Sportswear, Ltd.';
export const GEOMETRY_GLOBAL = 'Geometry Global (G2)';
export const GOOD_SAMARITAN_HOSPITAL = 'Good Samaritan Hospital; Suffern, NY and Warwick, NY';
export const HEINEKEN = 'Heineken USA';
export const HUDSON_NEWS_COMPANY = 'Hudson News Company';
export const HUDSON_VALLEY_COMMUNITY_SERVICES = 'Hudson Valley Community Services, Inc. (ARCS)';
export const HUDSON_VALLEY_HOSPITAL_CENTER = 'Hudson Valley Hospital Center';
export const INTEGRAMED_AMERICA = 'IntegraMed America';
export const JAMES_PETERS_VETERAN_AFFAIRS_MEDICAL =
  'James J. Peters Veteran Affairs Medical Center (JJP VA)';
export const KELLY_SERVICES = 'Kelly Services, Inc. at TTM Technologies';
export const KVL_AUDIO_VISUAL_SERVICES =
  'KVL Audio Visual Services, Inc.; includes AV Workshop and Spectrum AV';
export const LITTLE_ANGELS = 'Little Angels Day Care Center; Rye, NY';
export const MAIER_MARKEY = 'Maier, Markey, & Menashi, LLP (M3) and M4 Consultants, Inc.';
export const MARKEM_CORPORATION = 'MARKEM Corporation';
export const MATRIX = 'Matrix, LLC';
export const MERCY_COLLEGE = 'Mercy College';
export const MCDONALD_PAPER = 'McDonald Paper & Packing Co., Inc.';
export const MCKINSEY_COMPANY = 'McKinsey & Company';
export const NATIONAL_BUSINESS_AVIATION = 'National Business Aviation Association (NBAA)';
export const NUTRITION_21 = 'Nutrition 21, Inc.';
export const NY_ANNUAL_CONFERENCE =
  'NY Annual Conference of the Methodist Church; Memorial United Methodist Church and Trinity United Methodist Church; White Plains, NY';
export const ORBCOMM = 'ORBCOMM, Inc.';
export const ORGANIC_MILLING = 'Organic Milling';
export const PARAGON_GLOBAL = 'Paragon Global Resources, Inc.';
export const PERNOD_RICARD = 'Pernod Ricard USA';
export const PHILIP_MORRIS = 'Philip Morris International';
export const PRESTIGE_BRANDS = 'Prestige Brands Inc.';
export const RAMAPO_PRACTICE = 'Ramapo Practice Management, LLC';
export const RICHARD_FLESICHMAN = 'Richard Fleischman & Associates, Inc.';
export const RITTER_LABORATORIES = 'Ritter Laboratories; Suffern, NY';
export const ROBISON_OIL = 'Robison Oil';
export const SCARSDALE_PEDIATRIC = 'Scarsdale Pediatric Dental Associates, LLP';
export const SCHOEMAN_UPDIKE_KAUFMAN = 'Schoeman, Updike and Kaufman, LLP';
export const SELECT_SAVERS_CLUB = 'Select Savers Club';
export const SEVENTH_AVENUE_CENTER = 'Seventh Avenue Center for Family Services';
export const SOURCE_TECHNOLOGIES = 'Source Technologies';
export const STARPOINT_RESORT_GROUP = 'Starpoint Resort Group';
export const TEMPS_TODAY = 'Temps Today Inc.';
export const TENDER_CORPORATION = 'Tender Corporation';
export const TOMORROW_TEMPS = 'Tomorrow’s Temps';
export const TOPS_PERSONNEL = 'Tops Personnel Inc.';
export const TTM_TECHNOLOGIES = 'TTM Technologies, Inc.';
export const US_FOODSERVICE = 'US Foodservice Inc.; Bensenville, IL';
export const USI_INSURANCE_SERVICES = 'USI Insurance Services';

export const Quorum_SEG_LIST = [
  KRAFT,
  MASTERCARD,
  MONDELEZ_INTERATIONAL,
  THE_OGILVY_GROUP,
  HITACHI_METALS,
  AVON_PRODUCTS,
  THIRD_ANGLE_TECHNOLOGIES,
  ADVENTURE,
  ALLIED_BARTON,
  ALTRIA_GROUP,
  Ampacet,
  BASF,
  BAY_PERSONNEL,
  BISTRO,
  BRESNAN,
  CARL_ZEISS,
  CHARLES_IFERGAN,
  COMPASS,
  COUNCIL_ON_INTERNATIONAL_EDUCATIONAL_EXCHANGE,
  DATA_KEY_CONSULTING,
  DIAGEO_NORTH_AMERICA,
  DIAMOND_RESORTS_INTERNATIONAL,
  DURA_SUPREME,
  FILA,
  GAME_SPORTSWEAR,
  GEOMETRY_GLOBAL,
  GOOD_SAMARITAN_HOSPITAL,
  HEINEKEN,
  HUDSON_NEWS_COMPANY,
  HUDSON_VALLEY_COMMUNITY_SERVICES,
  HUDSON_VALLEY_HOSPITAL_CENTER,
  INTEGRAMED_AMERICA,
  JAMES_PETERS_VETERAN_AFFAIRS_MEDICAL,
  KELLY_SERVICES,
  KVL_AUDIO_VISUAL_SERVICES,
  LITTLE_ANGELS,
  MAIER_MARKEY,
  MARKEM_CORPORATION,
  MATRIX,
  MERCY_COLLEGE,
  MCDONALD_PAPER,
  MCKINSEY_COMPANY,
  NATIONAL_BUSINESS_AVIATION,
  NUTRITION_21,
  NY_ANNUAL_CONFERENCE,
  ORBCOMM,
  ORGANIC_MILLING,
  PARAGON_GLOBAL,
  PERNOD_RICARD,
  PHILIP_MORRIS,
  PRESTIGE_BRANDS,
  RAMAPO_PRACTICE,
  RICHARD_FLESICHMAN,
  RITTER_LABORATORIES,
  ROBISON_OIL,
  SCARSDALE_PEDIATRIC,
  SCHOEMAN_UPDIKE_KAUFMAN,
  SELECT_SAVERS_CLUB,
  SEVENTH_AVENUE_CENTER,
  SOURCE_TECHNOLOGIES,
  STARPOINT_RESORT_GROUP,
  TEMPS_TODAY,
  TENDER_CORPORATION,
  TOMORROW_TEMPS,
  TOPS_PERSONNEL,
  TTM_TECHNOLOGIES,
  US_FOODSERVICE,
  USI_INSURANCE_SERVICES,
];

export const NONE_OF_THE_EMPLOYERS = 'None Of The Employers';
export const ELIGIBLE = 'Eligible For One / More';
